import { ActionTree }                             from 'vuex';
import { RootState }                              from '@/store/store.types';
import { RateCheckerConfiguration } from '@/views/rate-checker-configuration/rate-checker/rate-checker.types';
import * as rateCheckerTableServices from '@/views/rate-checker-configuration/rate-checker-table/rate-checker-table.service';
import { RateCheckerTableState } from '@/views/rate-checker-configuration/rate-checker-table/rate-checker-table.types';
import { useGlobals } from '@/hooks/use-globals';
import * as rateCheckerServices from '@/views/rate-checker-configuration/rate-checker/rate-checker.service';

const actions: ActionTree<RateCheckerTableState, RootState> = {
  async getDataOfTableRateChecker({ state, commit }): Promise<void> {
    try {
      const { data }: { data: RateCheckerConfiguration } = await rateCheckerTableServices.getRateCheckerTable();
      commit('setTableData', data);
      commit('setTableHeader', data);
    } catch (e) {
      throw new Error(e);
    }
  },
  async checkRateChecker(): Promise<void> {
    const { router } = useGlobals();
    try {
      const { data } = await rateCheckerServices.checkRateChecker();
      if (!data.availability) {
        await router.push('/settings');
      }
    } catch (e) {
      await router.push('/settings');
      throw new Error(e);
    }
  },
};

export default actions;
